import bgTexture from '@assets/images/Hero/hero-bg.png'; // background image (same as about page bg)

export default function AboutMissionVision() {
  return (
    <section
      className="
        relative flex min-h-[60vh] w-full items-center justify-center overflow-hidden
        bg-[#0B0B0B] px-6
        text-white md:h-[50vh]
      "
      style={{
        backgroundImage: `url(${bgTexture})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Overlay for readability */}
      <div className="absolute inset-0 bg-black/60" />

      {/* Content (centered) */}
      <div
        className="
          relative z-10 mx-auto grid w-full max-w-5xl grid-cols-1
          place-items-center gap-4 text-center
          sm:gap-6
          md:grid-cols-2 md:gap-8
          lg:px-4
          2xl:max-w-7xl 
        "
      >
        {/* Mission */}
        <div
          data-aos="fade-right"
          className="
            flex h-full min-h-[220px]
            flex-col justify-center rounded-md bg-white/15 p-6
            text-center
            backdrop-blur-sm transition hover:bg-white/10
            sm:min-h-[240px]
          "
        >
          <h3 className="text-lg font-bold text-white sm:text-xl">Mission</h3>
          <p className="mt-3 text-sm leading-relaxed tracking-tighter text-gray-300 sm:text-base md:text-sm">
            To cater to the needs of Filipino security professionals and at-risk
            individuals seeking comfort and security in their ballistic
            protection, this technology provides enhanced protection
            capabilities through a lightweight, custom-fit design tailored to
            the local physique.
          </p>
        </div>

        {/* Vision */}
        <div
          data-aos="fade-left"
          className="
            flex h-full min-h-[220px]
            flex-col justify-center rounded-md bg-white/15 p-6
            text-center
            backdrop-blur-sm transition hover:bg-white/10
            sm:min-h-[240px]
          "
        >
          <h3 className="text-lg font-bold text-white sm:text-xl">Vision</h3>
          <p className="mt-3 text-sm leading-relaxed tracking-tighter text-gray-300 sm:text-base">
            A Filipino R&amp;D-defense technology company creating cutting-edge,
            locally manufactured ballistic systems.
          </p>
        </div>
      </div>
    </section>
  );
}
